import { createFileRoute } from "@tanstack/react-router";
import { LineCheckView } from "../app/views/lineCheck/lineCheckView";

export const Route = createFileRoute("/lineCheck")({
  component: LineCheckView,
});
